import { render, staticRenderFns } from "./Lauguages.vue?vue&type=template&id=42e3f465&scoped=true&"
import script from "./Lauguages.vue?vue&type=script&lang=js&"
export * from "./Lauguages.vue?vue&type=script&lang=js&"
import style0 from "./Lauguages.vue?vue&type=style&index=0&id=42e3f465&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e3f465",
  null
  
)

export default component.exports